export type ValueOf<T> = T[keyof T]

export function guardIsEnum<T extends { [key: string]: string | number }>(
  value: string | number | undefined,
  obj: T
): value is T[keyof T] {
  if (value === undefined) {
    return false
  }

  return Object.values(obj).includes(value)
}
